import { api } from '../axios';

export const getFollowByAddress = async (address: string) => {
  return await api.get(`/feed/follow/${address}`);
};

export const postFollowById = async (id: number) => {
  return api.post(`/feed/follow/change-status/${id}`);
};
